import React, { useEffect, useRef, useState } from "react";
import ToaAndReturnPolicyContent from "./ToaAndReturnPolicyContent";

type TermsAndAgreementsModalProps = {
  isDisclaimerEnabled?: boolean;
};

const TermsAndAgreementsModal = ({
  isDisclaimerEnabled = false,
}: TermsAndAgreementsModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const close = () => setIsOpen(false);

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {isDisclaimerEnabled && (
        <p className="lora-text text-sm" style={{ color: "#6b7280" }}>
          * By purchasing through our site you are agreeing to our Terms,
          Privacy &amp; Returns policies below.
        </p>
      )}
      <button className="page-section-link" onClick={() => setIsOpen(true)}>
        View Terms and Privacy Policy
      </button>

      {isOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) close();
          }}
          role="dialog"
          aria-modal="true"
          aria-label="Terms, Privacy and Returns Policy"
        >
          <div ref={containerRef} className="terms-modal-container">
            {/* ── Header ── */}
            <div className="terms-modal-header">
              <div className="terms-modal-header-left">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#8b4513"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <line x1="10" y1="9" x2="8" y2="9" />
                </svg>
                <h2 className="terms-modal-title">
                  Terms, Privacy &amp; Returns
                </h2>
              </div>
              <button
                onClick={close}
                aria-label="Close"
                className="terms-modal-close-btn"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* ── Scrollable body ── */}
            <div className="terms-modal-body">
              <ToaAndReturnPolicyContent />
            </div>

            {/* ── Footer ── */}
            <div className="terms-modal-footer">
              <span className="terms-modal-footer-note lora-text">
                Last updated: May 27, 2026
              </span>
              <button onClick={close} className="btn-primary">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TermsAndAgreementsModal;
